import React from "react";
import checkIcon from "./_assets/checkIcon.svg";

interface Props {
  agent: string | null;
}

const AgentInfo = ({ agent = "company-diligence-agent" }: Props) => {
  const V3 = [
    "Data Collection",
    "Insights Generation",
    "Challenge Mapping",
    "Persona Segmentation",
    "Support Strategy Recommendation",
    "Powerpoint Template Generation",
    "PowerPoint Generation",
  ];

  const V2 = [
    "Data collection",
    "Insights Extracted",
    "Challenge Mapping",
    "Persona Segmentation",
    "Support Strategy Development",
    "Interview Guide Draft",
    "PPT Template Generation",
    "PPT Generation",
  ];

 
  const data = agent === "qualitative-agent-v3" ? V3 : V2;

  return (
    <div className="lg:max-w-[215px] w-full bg-orange-50 gap-y-2 flex flex-col rounded-xl p-[12px]">

      {data.map((item: string, key: number) => (
        <div key={key} className="flex items-start gap-2">
          <span className="text-purple-600 text-xl w-6 h-3 rounded-full bg-primary-50 flex-[0_0_24px] inline-flex items-center justify-center">
            <img src={checkIcon} alt="" />
          </span>
          <p className="text-gray-800 flex-auto text-sm">
            {item}
          </p>
        </div>
      ))}

    </div>
  );
};

export default AgentInfo;
